// Regras da tela de seleção de empresa do MANAGER (telas/SelecionarEmpresa.jsx). Funções puras, sem I/O.

// Nome que aparece para o usuário: fantasia, ou razão social quando não houver
export function nomeDaEmpresa(empresa) {
  const e = empresa || {};
  return (e.nomeFantasia || '').trim() || (e.razaoSocial || '').trim() || 'Empresa sem nome';
}

export function formatarCnpj(cnpj) {
  const digitos = String(cnpj || '').replace(/\D/g, '');
  if (digitos.length !== 14) return cnpj || '';
  return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

const semAcento = (texto) => String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

// Busca por nome fantasia, razão social, cidade ou CNPJ (com ou sem pontuação), sem diferenciar acento/maiúscula.
// A empresa atual vem sempre primeiro; o resto mantém a ordem do servidor (alfabética).
export function filtrarEmpresas(empresas, busca) {
  const termo = semAcento(busca).trim();
  const digitos = String(busca || '').replace(/\D/g, '');
  const encontradas = (empresas || []).filter((e) => {
    if (!termo) return true;
    const textos = [e.nomeFantasia, e.razaoSocial, e.cidade].map(semAcento);
    if (textos.some((t) => t.includes(termo))) return true;
    return digitos.length > 0 && String(e.cnpj || '').replace(/\D/g, '').includes(digitos);
  });
  return [...encontradas.filter((e) => e.atual), ...encontradas.filter((e) => !e.atual)];
}

// Situação que merece aviso na lista; null quando a empresa está em dia
export function situacaoDaEmpresa(empresa) {
  if (!empresa.ativa) return 'Desativada';
  if (!empresa.periodoValido) return 'Período vencido';
  return null;
}
